import React, { useContext, useEffect, useState } from "react";
import SideNav from "../components/SideNav";
import DesignContext from "../components/contexts/DesignContext";
 
import { Context } from "../components/contexts/AppContext";

import Icons from "../components/Icons/index";
function Home() {

 

   const { value } = useContext(Context);  
   const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  let [temp, setTemp] = useState("NewFolderModal");
   
  let PropertyObj = Icons[temp]; 
useEffect(() => {
  setModalOpen(appState.modalData); // modalOpen को अपडेट करें
}, [appState.modalData]);

  // console.log('HOME JS====  ',appState)
  useEffect(() => {
    console.log("Open Modal Type ---",modalOpen.type)
    if (modalOpen.type === "NewFolderModal") {
      PropertyObj = Icons[modalOpen.type];
      setTemp(String("NewFolderModal"));
    }
    else  if (modalOpen.type === "NewGalleryModal") {
      PropertyObj = Icons["NewGalleryModal"];
      setTemp(String("NewGalleryModal"));
    }
   
  }, [modalOpen?.isOpen]);
  return (
    <>
      <DesignContext>
        <SideNav />
        {modalOpen.isOpen ? (
          <>
            <div id="MODAL_POPUP">
              <PropertyObj />
            </div>
          </>
        ) : (
          <></>
        )}

         
      </DesignContext>
    </>
  );
}

export default Home;
